import { graphql } from "@server/gql";

export const getTransactionQuery = graphql(/* GraphQL */ `
  query getTransaction($email: String!) {
    transactions(email: $email) {
      ...transaction
    }
  }
`);
